import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getPageTitle } from "../../../utils/pageTitle";

/**
 * HTPTV-714 — keeps document.title descriptive and per-route so GA4 Enhanced
 * Measurement records a distinct page_title for each page_view. Mounted once
 * inside <Router>; on every location change it sets the tab title to
 * "{Tenant} - {Page}" (logic lives in utils/pageTitle, which is unit-tested).
 */
const RouteTitle = () => {
  const { pathname } = useLocation();
  const title = getPageTitle(pathname);
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default RouteTitle;
